export default __webpack_public_path__ + "static/media/recycle-bin-icon.eef9701d.svg";